module.exports = __webpack_public_path__ + "static/yurtrus-symbol-DND3_FnP-eb45090fc3934ad678d39c0c1ef8015d.webp";